import { MASK as i } from "./index.es543.js";
var l = function l(e) {
    return typeof e == "number" ? /^\d$/ : new RegExp("^".concat(e, "$"));
  },
  S = function S(e) {
    if (e.length === i.length) return e;
    var t = l(i[e.length]),
      n = function n(s) {
        return t.test(s) ? s : "";
      };
    var r = e;
    return r += n("-"), r += n(":"), r += n(" "), r;
  },
  u = function u(e) {
    var t = e.getFullYear().toString().substring(2, 4).padStart(2, "0"),
      n = (e.getMonth() + 1).toString().padStart(2, "0"),
      r = e.getDate().toString().padStart(2, "0"),
      s = e.getHours().toString().padStart(2, "0"),
      a = e.getMinutes().toString().padStart(2, "0");
    return "".concat(t, "-").concat(n, "-").concat(r, " ").concat(s, ":").concat(a);
  },
  o = function o(e, t) {
    return new Date((/* @__PURE__ */new Date()).setFullYear(e, t + 1, 0)).getDate();
  },
  c = function c(e) {
    var t = 2e3 + Number(e.substring(0, 2)),
      n = Math.min(Number(e.substring(3, 5)) - 1, 11),
      r = Math.min(Number(e.substring(6, 8)), o(t, n)),
      s = Math.min(Number(e.substring(9, 11)), 23),
      a = Math.min(Number(e.substring(12, 14)), 59);
    return new Date(t, n, r, s, a, 0);
  },
  g = function g(e) {
    var t = e;
    if (t.length >= 4) {
      var n = t.slice(3, 5);
      Number(t[3]) > 1 && (n = t[3].padStart(2, "0")), n === "00" && (n = "01"), t = t.slice(0, 3) + n + t.slice(5);
    }
    return t;
  },
  m = function m(e) {
    var t = e;
    if (t.length >= 7) {
      var n = o(2e3 + Number(t.slice(0, 2)), Number(t.slice(3, 5)) - 1),
        r = t.slice(6, 8),
        s = r.length === 1 && Number(r) > Math.floor(n / 10) || Number(r) > n ? r[0].padStart(2, "0") : r;
      t = t.slice(0, 6) + (s === "00" ? "01" : s) + t.slice(8);
    }
    return t;
  },
  h = function h(e) {
    var t = e;
    if (t.length >= 10) {
      var n = t.slice(9, 11);
      Number(n[0]) > 2 && (n = n[0].padStart(2, "0")), t = t.slice(0, 9) + n + t.slice(11);
    }
    return t;
  },
  b = function b(e) {
    var t = e;
    if (t.length >= 13) {
      var n = t.slice(12, 14);
      Number(n[0]) > 5 && (n = n[0].padStart(2, "0")), t = t.slice(0, 12) + n;
    }
    return t;
  },
  p = function p(e) {
    var t = e;
    return t = g(t), t = m(t), t = h(t), t = b(t), u(c(t + "01-01-01 01:01".slice(t.length))).slice(0, t.length);
  };
export { S as autoFillSeparators, u as dateToValue, l as generateRegExp, p as validateValue, c as valueToDate };